<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Confirmação de Dados Pessoais</h1>
        </header>

        <vs-row>
          <NewSale />
        </vs-row>

        <vs-card
          v-for="(item, index) in dataClient.itens"
          :key="index"
          v-show="item.visible"
        >
          <p v-if="index == 0">
            {{ dataClient.introduction }}
          </p>
          <div slot="header">
            <h3>
              {{ item.name }}
            </h3>
          </div>

          <fieldset class="fieldErrors" v-if="errors.count() > 0">
            <legend>Atenção aos erros do formulário:</legend>
            <ul>
              <li
                v-for="(error, index) in errors.all()"
                :key="index"
                class="alert"
              >
                {{ error }}
              </li>
            </ul>
          </fieldset>
          <p v-html="item.message"></p>
          <p v-if="item.field == 'nome_cliente'">
            <label>Nome Fantasia</label>
            <vs-input
              v-model="personalData.FANTASIA_CLIENTE"
              :value="personalData.FANTASIA_CLIENTE"
              v-validate="'required'"
              data-vv-as="Nome Social / Nome Fantasia"
            />
          </p>
          <p v-if="item.field == 'email_cliente'">
            <vs-input
              v-model="personalData.EMAIL_CLIENTE"
              :value="personalData.EMAIL_CLIENTE"
              v-validate="'required|email'"
              data-vv-as="E-mail do Cliente"
            />
          </p>

          <p v-if="item.field == 'nascimento-cliente'">
            <i>({{ calculateAge() }} anos)</i>
          </p>

          <p v-if="item.field == 'endereco_cliente'">
            <label>CEP</label>
            <vs-input
              v-mask="'#####-###'"
              v-model="personalData.CEP_CLIENTE"
              @keyup.enter="getAddressByCEP()"
              class="qi-input"
              v-validate="'required|regex:^([0-9]{5}-[0-9]{3})$'"
              data-vv-as="CEP"
            />
            <vs-button
              icon="search"
              style="width: 100%; margin-top: 10px"
              @click="getAddressByCEP()"
            >
              Buscar
            </vs-button>
          </p>

          <p
            style="margin-top: 80px !important"
            v-if="item.field == 'endereco_cliente'"
          >
            <label> Rua / Avenida </label>
            <vs-input
              v-model="personalData.NOMERUA_CLIENTE"
              :danger="
                !personalData.NOMERUA_CLIENTE.length > 0 ||
                personalData.NOMERUA_CLIENTE.length > 60
              "
              danger-text="O campo endereço não pode ser vazio ou ter mais que 60 caracteres!"
              name="NomeRua"
              v-validate="'required'"
              data-vv-as="Logradouro"
            /><br />
            <label> Número </label>
            <vs-input
              v-model="personalData.NUMERO_CLIENTE"
              name="Numero"
              v-validate="'required'"
              data-vv-as="Número"
            /><br />
            <label> Complemento (Se Houver) </label>
            <vs-input
              v-model="personalData.COMPLEMENTO_CLIENTE"
              name="Comple"
            /><br />
          </p>

          <p v-if="item.field == 'endereco_cliente'">
            <label> Estado </label>
            <vs-select
              width="100%"
              placeholder="Selecione um Estado"
              autocomplete
              v-model="personalData.ESTADO_CLIENTE"
              :value="personalData.ESTADO_CLIENTE"
              v-on:input="changeProvinces($event)"
              v-validate="'required'"
              data-vv-as="Estado"
            >
              <vs-select-item
                v-for="(option, i) in states"
                :key="i"
                :value="option.CODIGO"
                :text="option.NOME"
              />
            </vs-select>
            <br />
            <label> Cidade </label>
            <vs-select
              width="100%"
              placeholder="Selecione uma Cidade"
              autocomplete
              v-model="personalData.CODMUNICIPIO_CLIENTE"
              :value="personalData.CODMUNICIPIO_CLIENTE"
              v-validate="'required'"
              data-vv-as="Cidade"
            >
              <vs-select-item
                v-for="(municipio, i) in cities"
                :key="i"
                :value="municipio.value.CODIGO"
                :text="municipio.title"
              /> </vs-select
            ><br />
            <label> Bairro </label>
            <vs-input
              v-model="personalData.BAIRRO_CLIENTE"
              v-validate="'required'"
              data-vv-as="Bairro"
            /><br />
          </p>
          <p v-if="item.field == 'telefones_cliente'">
            <label> Telefone Principal: </label>
            <vs-input
              v-mask="'(##) ####-#####'"
              v-model="personalData.TELEFONE1_CLIENTE"
              :value="personalData.TELEFONE1_CLIENTE"
              v-validate="'required'"
              data-vv-as="Telefone principal"
            /><br />
            <label> Telefone para Recados: </label>
            <vs-input
              v-mask="'(##) ####-#####'"
              v-model="personalData.TELEFONE2_CLIENTE"
              :value="personalData.TELEFONE2_CLIENTE"
              v-validate="'required'"
              data-vv-as="Telefone para recados"
            />
          </p>
          <p v-if="item.field == 'documentos_cliente'">
            <label>Agora me informe o seu RG? </label>
            <vs-input
              v-model="personalData.RG_CLIENTE"
              :value="personalData.RG_CLIENTE"
              data-vv-as="RG"
            />
          </p>
          <div>
            <vs-row>
              <vs-divider />
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="arrow_back"
                  style="width: 100%"
                  @click="back(item, index)"
                  v-if="item.field !== 'nome_cliente'"
                >
                  Voltar
                </vs-button>
              </vs-col>
              <vs-col vs-lg="6" vs-sm="12">
                <vs-button
                  icon="check_circle"
                  style="width: 100%"
                  color="#139B0E"
                  @click="confirmAdvance(item, index)"
                >
                  Confirmar e Avançar
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </vs-card>
        <vs-card style="height: 270px">
          <h2>Divergência</h2>
          <Divergence />
        </vs-card>
        <vs-card style="height: 140px">
          <h2>Cancelamento</h2>
          <!--Componente Cancelamento de Pré-->
          <ReasonsCancel />
        </vs-card>
      </section>
    </div>
  </div>
</template>
<script>
import AuditModel from "../model/Audit.js";
import AuditService from "../services/audits.js";
import PersonService from "../services/person";
import { getStepsInformation, notifyError } from "../helpers/index.js";
import { formatDateToLocale } from "../helpers";
import ServiceAudit from "../services/mailing";
import Divergence from "../components/Divergence.vue";
import ReasonsCancel from "../components/ReasonsCancel.vue";

export default {
  name: "AuditStep1B",
  components: {
    Divergence,
    ReasonsCancel,
  },
  data: () => ({
    dataClient: null,
    coligateId: null,
    preRegistrationId: null,
    cities: [],
    states: [],
    personalData: {
      BAIRRO_CLIENTE: "",
      CEP_CLIENTE: "",
      COLIGADA_CLIENTE: "",
      CPF_CLIENTE: "",
      EMAIL_CLIENTE: "",
      ESTADO_CLIENTE: "",
      MUNICIPIO_CLIENTE: "",
      NASCIMENTO_CLIENTE: "",
      NUMERO_CLIENTE: "",
      COMPLEMENTO_CLIENTE: "",
      NOMERUA_CLIENTE: "",
      NOME_CLIENTE: "",
      RG_CLIENTE: "",
      TELEFONE1_CLIENTE: "",
      TELEFONE2_CLIENTE: "",
      TIPOPESSOA_CLIENTE: "",
      TIPORUA_CLIENTE: "",
      TIPO_CLIENTE: "",
      hasRG: false,
    },
    succesUpdateClient: false,
    error: null,
  }),
  created() {
    //montagem do objeto de confirmações financeiras
    this.dataClient = new AuditModel().getItem("dataClient");
    this.getStates();
    this.changeProvinces("RS");
    //puxar a pré que está salva na sessão e busca os dados da pré no endpoint
    const stepsData = getStepsInformation();
    const preRegistrationId = stepsData.preRegistrationId;

    this.$vs.loading();
    new AuditService()
      .getPersonalData(preRegistrationId)
      .then((res) => {
        Object.assign(this.personalData, res.data);
        console.log(this.personalData);
        if (this.personalData.RG_CLIENTE != "") this.personalData.hasRG = true;

        if (this.personalData.ESTADO_CLIENTE == "") {
          this.personalData.ESTADO_CLIENTE = "RS";
        }

        this.$vs.loading.close();
        this.dataClient = JSON.stringify(this.dataClient);

        this.dataClient = this.dataClient.replaceAll(
          "@NOME_CLIENTE",
          this.personalData.NOME_CLIENTE
        );
        this.dataClient = this.dataClient.replace(
          "@NASCIMENTO_CLIENTE",
          formatDateToLocale(this.personalData.NASCIMENTO_CLIENTE)
        );
        this.dataClient = this.dataClient.replace(
          "@CPF_CLIENTE",
          this.personalData.CPF_CLIENTE
        );
        this.dataClient = this.dataClient.replace(
          "@RG_CLIENTE",
          this.personalData.RG_CLIENTE
        );
        this.dataClient = JSON.parse(this.dataClient);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    calculateAge() {
      const birthDate = new Date(this.personalData.NASCIMENTO_CLIENTE);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },

    getAddressByCEP() {
      this.personalData.NUMERO_CLIENTE = "";
      this.personalData.COMPLEMENTO_CLIENTE = "";
      this.personalData.BAIRRO_CLIENTE = "";
      this.personalData.NOMERUA_CLIENTE = "";
      this.$vs.loading();
      new AuditService()
        .getAddressByCEP(this.personalData.CEP_CLIENTE)
        .then((res) => {
          this.adress = res.data;
          this.personalData.NOMERUA_CLIENTE = this.adress.LOGRADOURO;
          this.personalData.BAIRRO_CLIENTE = this.adress.BAIRRO;
          this.personalData.ESTADO_CLIENTE = this.adress.UF;
          this.personalData.MUNICIPIO_CLIENTE = this.adress.CIDADE;
          this.personalData.TIPORUA_CLIENTE = this.address.CODTIPORUA;
        })
        .catch((error) => {
          console.error("Error", error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getStates() {
      new ServiceAudit()
        .getStates()
        .then((res) => {
          this.states = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changeProvinces(state) {
      new ServiceAudit()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.cities = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
        });
    },

    async confirmAdvance(item, index) {
      item.visible = false;
      item.valid = true;
      if (index == this.dataClient.itens.length - 1) {
        this.$validator.validate().then(async (valid) => {
          if (!valid) {
            notifyError(this, "Corrigir os erros apresentados.");
            item.visible = true;
            return;
          } else {
            await this.saveClientData();
            this.$router.push("/audits/2");
          }
        });
      } else {
        this.dataClient.itens[index + 1].visible = true;
      }
    },
    back(item, index) {
      item.visible = false;
      item.valid = true;
      this.dataClient.itens[index - 1].visible = true;
    },

    async saveClientData() {
      this.succesUpdateClient = false;
      const clientData = {
        NOMEFANTASIA: this.personalData.FANTASIA_CLIENTE,
        NOME: this.personalData.NOME_CLIENTE,
        CGCCFO: this.personalData.CPF_CLIENTE,
        TELEFONE: this.personalData.TELEFONE1_CLIENTE.replace(/\D/g, ""),
        TELEX: this.personalData.TELEFONE2_CLIENTE.replace(/\D/g, ""),
        EMAIL: this.personalData.EMAIL_CLIENTE,
        PESSOAFISOUJUR: this.personalData.TIPOPESSOA_CLIENTE,
        DTNASCIMENTO: this.personalData.NASCIMENTO_CLIENTE,
        CODMUNICIPIO: this.personalData.CODMUNICIPIO_CLIENTE,
        CODCOLCFO: this.personalData.COLIGADA_CLIENTE,
        CODCFO: this.personalData.CODIGO_CLIENTE,
        BAIRRO: this.personalData.BAIRRO_CLIENTE,
        CEP: this.personalData.CEP_CLIENTE,
        NUMERO: this.personalData.NUMERO_CLIENTE,
        COMPLEMENTO: this.personalData.COMPLEMENTO_CLIENTE,
        CODETD: this.personalData.ESTADO_CLIENTE,
        TIPORUA: this.personalData.TIPORUA_CLIENTE,
        RUA: this.personalData.NOMERUA_CLIENTE,
        CIDENTIDADE: this.personalData.RG_CLIENTE,
        isNew: false,
      };
      this.$vs.loading();
      await new PersonService()
        .newClientPerson(clientData)
        .then(() => {
          this.succesUpdateClient = true;
        })
        .catch(( error ) => {
          notifyError(
            this,
            "Erro ao tentar atualizar os dados do responsável: " + error.response.data.error
          );
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
};
</script>
<style scoped>
p {
  margin-top: 1em;
}
</style>
